module.exports = __webpack_public_path__ + "static/media/graphics2.6aaf4900.png";